/**
 * A custom hook that triggers a callback whenever a change is detected after initial mount
 * Similar to componentDidUpdate
 * (useEffect triggers on initial render)
 *
 * @param {Function} callback The callback triggered on change
 * @param {Array} deps The prop to watch for updates
 */

import {
  useEffect,
  useRef,
} from 'react';

const useDidUpdate = (callback: Function, deps: any[]) => {

  const hasMounted = useRef(false);

  useEffect(() => {

    if (hasMounted.current) {

      callback();

    } else {

      hasMounted.current = true;

    }

  }, deps);

};

export default useDidUpdate;
